import { useState } from "react";
import {
  ActiveCodeComponent,
  PasswordComponent,
  UserNameComponent,
} from "./loginComponent/LoginValidateComponent";
import Swal from "sweetalert2";
import { ActiveCodeService, RegisterService } from "../../services/MainScreen";

import { Link, useNavigate } from "react-router-dom";
import {
  CHANGE_PASSWORD_URL_LOCAL,
  LOGIN_URL_LOCAL,
} from "../../utility/BaseUrl";

const Register = () => {
  const [registerLoading, setRegisterLoading] = useState(false);
  const [name, setName] = useState("");
  const [family, setFamily] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [activeCode, setActiveCode] = useState(0);
  const [level, setLevel] = useState(0);

  const navigate = useNavigate();

  const showAlert = (icon, title, text) => {
    Swal.fire({
      icon,
      title,
      text,
      confirmButtonText: "باشه",
    });
  };

  const validateForm = () => {
    if (!name.trim()) {
      showAlert("error", "خطا", "نام را وارد کنید.");
      return false;
    }
    if (!family.trim()) {
      showAlert("error", "خطا", "نام خانوادگی را وارد کنید.");
      return false;
    }
    if (phone.length !== 11) {
      showAlert("error", "خطا", "شماره موبایل باید 11 رقم باشد.");
      return false;
    }
    if (password.length < 6) {
      showAlert("error", "خطا", "رمز عبور باید حداقل 6 کاراکتر باشد.");
      return false;
    }

    return true;
  };

  const handleRegister = async () => {
    if (!validateForm()) return;

    setRegisterLoading(true);
    try {
      const result = await RegisterService(
        family,
        name,
        password,
        password,
        phone
      );
      if (result.status === 0) {
        console.log(result.error);
        return;
      } else if (result.status === 200) {
        showAlert("success", "عملیات موفق", result.message);
        setLevel(1);
        setActiveCode(result.result.active_code);
      } else {
        let html = `<li> ${result.result.user_phone[0]} </li>`;
        if (result?.result?.password)
          html += `<li> ${result.result.password[0]} </li>`;

        Swal.fire({
          icon: "error",
          title: result.message,
          html: `<ul>${html}</ul>`,
          confirmButtonText: "باشه",
          preConfirm: () => {
            if (result?.result?.user_phone) navigate(LOGIN_URL_LOCAL);
          },
        });
      }
    } catch (error) {
      showAlert("error", "خطا", "مشکلی در ثبت‌نام رخ داده است.");
    } finally {
      setRegisterLoading(false);
    }
  };

  const handleActivation = async () => {
    setRegisterLoading(true);
    const response = await ActiveCodeService(activeCode, phone);
    if (response.status === 400) {
      let html = `<li> ${response.result.user_phone[0]} </li>`;
      if (response?.result?.active_code)
        html += `<li> ${response.result.active_code[0]} </li>`;

      Swal.fire({
        icon: "error",
        title: response.message,
        html: `<ul>${html}</ul>`,
        confirmButtonText: "باشه",
      });
    } else {
      showAlert("success", "موفقیت", response.message);
      navigate(LOGIN_URL_LOCAL);
    }

    setRegisterLoading(false);
  };

  return (
    <main className="page-container register-container">
      <div className="container">
        <div className="row">
          <div className="col-3"></div>
          <div className="col-12 col-md-6">
            <h1 className="page-title pb-20 mt-3 register-title pt-20 pt-md-25 pt-lg-30 text-center w-100">
              ثبت‌نام در وب‌سایت
            </h1>
            <div className="page-context register-context text-center">
              {level === 0 ? (
                <form
                  name="register"
                  className="register-form py-25 py-sm-30 py-md-35 pt-lg-10 pb-lg-10"
                  onSubmit={(event) => {
                    event.preventDefault();
                    handleRegister();
                  }}
                >
                  <div className="row form-group register-name">
                    <label
                      htmlFor="name"
                      className="col-form-label col-md-3 text-md-left register-name-label"
                    >
                      نام
                    </label>
                    <div className="col-12">
                      <input
                        onChange={(e) => setName(e.target.value)}
                        type="text"
                        value={name}
                        name="name"
                        className="form-control register-name-input"
                        placeholder="نام"
                      />
                    </div>
                  </div>
                  <div className="row form-group register-family">
                    <label
                      htmlFor="family"
                      className="col-form-label col-md-3 text-md-left register-family-label"
                    >
                      نام خانوادگی
                    </label>
                    <div className="col-12">
                      <input
                        onChange={(e) => setFamily(e.target.value)}
                        type="text"
                        value={family}
                        name="family"
                        className="form-control register-family-input"
                        placeholder="نام خانوادگی"
                      />
                    </div>
                  </div>
                  <UserNameComponent phone={phone} setPhone={setPhone} />
                  <PasswordComponent
                    password={password}
                    setPassword={setPassword}
                  />
                  <div className="row form-group register-submit mt-20">
                    <div className="col-12 text-center">
                      <button
                        type="submit"
                        className="btn btn-lg btn-primary signin-submit shadow"
                        style={{ padding: "0.4625rem 1.1875rem" }}
                        disabled={registerLoading}
                      >
                        ثبت‌نام
                      </button>
                      {registerLoading && (
                        <div className="page-loading register-loading">
                          <i className="fa fa-refresh fa-spin fa-fw" />
                          لطفاً صبر کنید...
                        </div>
                      )}
                    </div>
                  </div>
                </form>
              ) : (
                <div className="register-form py-25 py-sm-30 py-md-35 pt-lg-10 pb-lg-10">
                  <ActiveCodeComponent
                    activeCode={activeCode}
                    goToNextSlide={handleActivation}
                  />
                  <div className="row form-group register-submit mt-20">
                    <div className="col-12 text-center">
                      <button
                        type="button"
                        className="btn btn-lg btn-primary signin-submit shadow"
                        style={{ padding: "0.4625rem 1.1875rem" }}
                        disabled={registerLoading}
                      >
                        فعال سازی حساب
                      </button>
                      {registerLoading && (
                        <div className="page-loading register-loading">
                          <i className="fa fa-refresh fa-spin fa-fw" />
                          لطفاً صبر کنید...
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
              <div className="container">
                <div className="row form-group mb-0 mt-10 p-10 bg-white align-items-center text-md-right rounded">
                  <div className="col-12 col-md-6">حساب کاربری دارید؟</div>
                  <div className="col-12 col-md-6 text-center text-md-left">
                    <Link
                      to={LOGIN_URL_LOCAL}
                      className="signin-signup btn mt-10 mt-md-1"
                      style={{ padding: "0.4625rem 1.1875rem" }}
                    >
                      ورود به حساب
                    </Link>
                  </div>
                </div>
                <div className="row mt-2 form-group mb-0 mt-10 align-items-center p-10 bg-white text-md-right rounded">
                  <div className="col-12 col-md-6">
                    رمز عبور خود را فراموش کرده‌اید؟
                  </div>
                  <div className="col-12 col-md-6 text-center text-md-left">
                    <Link
                      to={CHANGE_PASSWORD_URL_LOCAL}
                      className="signin-signupb btn mt-10 mt-md-1"
                      style={{ padding: "0.4625rem 1.1875rem" }}
                    >
                      بازیابی رمز عبور
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-3"></div>
        </div>
      </div>
    </main>
  );
};

export default Register;
